/**
 * FollowupAutoRouter — mobile/tablet use unified CareFlow app; desktop keeps FollowupHome.
 */
import React from "react";
import { isMobile, isTablet } from "../../utils/device";
import FollowupHome from "./FollowupHome";
import FastBilling from "../../pages/FastBilling";

export default function FollowupAutoRouter() {
    if (isMobile() || isTablet()) {
        return <FastBilling />;
    }
    return <FollowupHome />;
}
